"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _User = _interopRequireDefault(require("./User"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The AutomationEvent model module.
 * @module model/AutomationEvent
 * @version 2.7.64
 */
var AutomationEvent = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>AutomationEvent</code>.
   * Event which was automatically done by the shipwell system
   * @alias module:model/AutomationEvent
   * @param scheduledFor {Date} 
   * @param source {module:model/AutomationEvent.SourceEnum} 
   * @param subType {module:model/AutomationEvent.SubTypeEnum} 
   * @param type {module:model/AutomationEvent.TypeEnum} 
   */
  function AutomationEvent(scheduledFor, source, subType, type) {
    _classCallCheck(this, AutomationEvent);

    AutomationEvent.initialize(this, scheduledFor, source, subType, type);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(AutomationEvent, null, [{
    key: "initialize",
    value: function initialize(obj, scheduledFor, source, subType, type) {
      obj['scheduled_for'] = scheduledFor;
      obj['source'] = source;
      obj['sub_type'] = subType;
      obj['type'] = type;
    }
    /**
     * Constructs a <code>AutomationEvent</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AutomationEvent} obj Optional instance to populate.
     * @return {module:model/AutomationEvent} The populated <code>AutomationEvent</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new AutomationEvent();

        if (data.hasOwnProperty('answered_by_machine')) {
          obj['answered_by_machine'] = _ApiClient["default"].convertToType(data['answered_by_machine'], 'Boolean');
        }

        if (data.hasOwnProperty('completed_at')) {
          obj['completed_at'] = _ApiClient["default"].convertToType(data['completed_at'], 'Date');
        }

        if (data.hasOwnProperty('conversation_status')) {
          obj['conversation_status'] = _ApiClient["default"].convertToType(data['conversation_status'], 'String');
        }

        if (data.hasOwnProperty('created_at')) {
          obj['created_at'] = _ApiClient["default"].convertToType(data['created_at'], 'Date');
        }

        if (data.hasOwnProperty('estimated_eta')) {
          obj['estimated_eta'] = _ApiClient["default"].convertToType(data['estimated_eta'], 'Date');
        }

        if (data.hasOwnProperty('estimated_location_name')) {
          obj['estimated_location_name'] = _ApiClient["default"].convertToType(data['estimated_location_name'], 'String');
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('parsed_message')) {
          obj['parsed_message'] = _ApiClient["default"].convertToType(data['parsed_message'], 'String');
        }

        if (data.hasOwnProperty('recorded_audio')) {
          obj['recorded_audio'] = _ApiClient["default"].convertToType(data['recorded_audio'], 'String');
        }

        if (data.hasOwnProperty('response_message')) {
          obj['response_message'] = _ApiClient["default"].convertToType(data['response_message'], 'String');
        }

        if (data.hasOwnProperty('resulting_alert_level')) {
          obj['resulting_alert_level'] = _ApiClient["default"].convertToType(data['resulting_alert_level'], 'String');
        }

        if (data.hasOwnProperty('scheduled_by_user')) {
          obj['scheduled_by_user'] = _User["default"].constructFromObject(data['scheduled_by_user']);
        }

        if (data.hasOwnProperty('scheduled_for')) {
          obj['scheduled_for'] = _ApiClient["default"].convertToType(data['scheduled_for'], 'Date');
        }

        if (data.hasOwnProperty('shipment')) {
          obj['shipment'] = _ApiClient["default"].convertToType(data['shipment'], 'String');
        }

        if (data.hasOwnProperty('source')) {
          obj['source'] = _ApiClient["default"].convertToType(data['source'], 'String');
        }

        if (data.hasOwnProperty('sub_type')) {
          obj['sub_type'] = _ApiClient["default"].convertToType(data['sub_type'], 'String');
        }

        if (data.hasOwnProperty('timeline_ordering_timestamp')) {
          obj['timeline_ordering_timestamp'] = _ApiClient["default"].convertToType(data['timeline_ordering_timestamp'], 'Date');
        }

        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'String');
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }
      }

      return obj;
    }
  }]);

  return AutomationEvent;
}();
/**
 * @member {Boolean} answered_by_machine
 */


AutomationEvent.prototype['answered_by_machine'] = undefined;
/**
 * @member {Date} completed_at
 */

AutomationEvent.prototype['completed_at'] = undefined;
/**
 * @member {module:model/AutomationEvent.ConversationStatusEnum} conversation_status
 */

AutomationEvent.prototype['conversation_status'] = undefined;
/**
 * @member {Date} created_at
 */

AutomationEvent.prototype['created_at'] = undefined;
/**
 * @member {Date} estimated_eta
 */

AutomationEvent.prototype['estimated_eta'] = undefined;
/**
 * @member {String} estimated_location_name
 */

AutomationEvent.prototype['estimated_location_name'] = undefined;
/**
 * @member {String} id
 */

AutomationEvent.prototype['id'] = undefined;
/**
 * @member {String} parsed_message
 */

AutomationEvent.prototype['parsed_message'] = undefined;
/**
 * URL to an mp3 file holding recorded audio of the conversation of the event, if exists
 * @member {String} recorded_audio
 */

AutomationEvent.prototype['recorded_audio'] = undefined;
/**
 * @member {String} response_message
 */

AutomationEvent.prototype['response_message'] = undefined;
/**
 * @member {module:model/AutomationEvent.ResultingAlertLevelEnum} resulting_alert_level
 */

AutomationEvent.prototype['resulting_alert_level'] = undefined;
/**
 * @member {module:model/User} scheduled_by_user
 */

AutomationEvent.prototype['scheduled_by_user'] = undefined;
/**
 * @member {Date} scheduled_for
 */

AutomationEvent.prototype['scheduled_for'] = undefined;
/**
 * @member {String} shipment
 */

AutomationEvent.prototype['shipment'] = undefined;
/**
 * @member {module:model/AutomationEvent.SourceEnum} source
 */

AutomationEvent.prototype['source'] = undefined;
/**
 * @member {module:model/AutomationEvent.SubTypeEnum} sub_type
 */

AutomationEvent.prototype['sub_type'] = undefined;
/**
 * Timestamp used in the default ordering of events. Will use completed_at if it is not null, otherwise will fall back on scheduled_for. 
 * @member {Date} timeline_ordering_timestamp
 */

AutomationEvent.prototype['timeline_ordering_timestamp'] = undefined;
/**
 * @member {module:model/AutomationEvent.TypeEnum} type
 */

AutomationEvent.prototype['type'] = undefined;
/**
 * @member {Date} updated_at
 */

AutomationEvent.prototype['updated_at'] = undefined;
/**
 * Allowed values for the <code>conversation_status</code> property.
 * @enum {String}
 * @readonly
 */

AutomationEvent['ConversationStatusEnum'] = {
  /**
   * value: "busy"
   * @const
   */
  "busy": "busy",

  /**
   * value: "canceled"
   * @const
   */
  "canceled": "canceled",

  /**
   * value: "completed"
   * @const
   */
  "completed": "completed",

  /**
   * value: "failed"
   * @const
   */
  "failed": "failed",

  /**
   * value: "in-progress"
   * @const
   */
  "in-progress": "in-progress",

  /**
   * value: "no-answer"
   * @const
   */
  "no-answer": "no-answer",

  /**
   * value: "queued"
   * @const
   */
  "queued": "queued",

  /**
   * value: "ringing"
   * @const
   */
  "ringing": "ringing"
};
/**
 * Allowed values for the <code>resulting_alert_level</code> property.
 * @enum {String}
 * @readonly
 */

AutomationEvent['ResultingAlertLevelEnum'] = {
  /**
   * value: "HIGH"
   * @const
   */
  "HIGH": "HIGH",

  /**
   * value: "MEDIUM"
   * @const
   */
  "MEDIUM": "MEDIUM",

  /**
   * value: "LOW"
   * @const
   */
  "LOW": "LOW"
};
/**
 * Allowed values for the <code>source</code> property.
 * @enum {String}
 * @readonly
 */

AutomationEvent['SourceEnum'] = {
  /**
   * value: "CALL"
   * @const
   */
  "CALL": "CALL",

  /**
   * value: "TEXT"
   * @const
   */
  "TEXT": "TEXT",

  /**
   * value: "EMAIL"
   * @const
   */
  "EMAIL": "EMAIL"
};
/**
 * Allowed values for the <code>sub_type</code> property.
 * @enum {String}
 * @readonly
 */

AutomationEvent['SubTypeEnum'] = {
  /**
   * value: "LOCATION_CHECK_IN"
   * @const
   */
  "LOCATION_CHECK_IN": "LOCATION_CHECK_IN",

  /**
   * value: "PRE_PICKUP"
   * @const
   */
  "PRE_PICKUP": "PRE_PICKUP"
};
/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */

AutomationEvent['TypeEnum'] = {
  /**
   * value: "CALL"
   * @const
   */
  "CALL": "CALL",

  /**
   * value: "TEXT"
   * @const
   */
  "TEXT": "TEXT",

  /**
   * value: "EMAIL"
   * @const
   */
  "EMAIL": "EMAIL"
};
var _default = AutomationEvent;
exports["default"] = _default;